// Referencing axios in this way is considered a better practice than using window.axios in main.js
// see https://stackoverflow.com/questions/51374367/axios-is-not-defined-in-vue-js-cli
import axiosHttp from 'axios'
export const axios = axiosHttp

export default {
  install (Vue, options) {
    Vue.prototype.$axios = axiosHttp
  }
}
